import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IAnsweredSurvey } from "../../../../common/data/dtos/answered-survey";
import Badge from "../../../../components/bootstrap/Badge";
import Card, { CardBody, CardHeader, CardLabel, CardTitle } from "../../../../components/bootstrap/Card";
import { MoreActions } from "../../../../components/extras/MoreActions";
import { showWarning } from "../../../../components/extras/Notifications";
import PaginationButtons, { dataPagination, PER_COUNT } from "../../../../components/PaginationButtons";
import { hiddenMenu } from "../../../../menu";
import answeredSurveyService from "../../../../services/answered-survey-service";
import LoadingPage from "../../loading/LoadingPage";

export const CommonAnsweredSurveyList = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(PER_COUNT['10']);

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isModalOpened, setIsModalOpened] = useState(false);

    const [answeredSurveys, setaAnsweredSurveys] = useState<IAnsweredSurvey[]>([]);
    const [selectedAnsweredSurvey, setSelectedAnsweredSurvey] = useState<IAnsweredSurvey | null>(null);

    const navigate = useNavigate();

    useEffect(() => {
        fetchAnsweredSurveys();
    }, []);

    const fetchAnsweredSurveys = async () => {
        setIsLoading(true);

        const response = await answeredSurveyService.getAnsweredSurveys();

        setIsLoading(false);

        if (response.error) {
            showWarning(response.error);
            return;
        }

        setaAnsweredSurveys(response.answeredSurveys || []);
    };

    const handleAnsweredSurveyClick = async (answeredSurvey: IAnsweredSurvey) => {
        if (answeredSurvey.id) navigate(`../${hiddenMenu.answeredSurveyDetail.path.replace(':id', answeredSurvey.id)}`);
    };

    if (isLoading) {
        return <LoadingPage />;
    }

    return (
        <>
            <Card style={{ minHeight: 600 }}>
                <CardHeader borderSize={1}>
                    <CardLabel icon="Feed" iconColor="primary">
                        <CardTitle tag="div" className="h5">
                            Questionários respondidos
                        </CardTitle>
                    </CardLabel>
                </CardHeader>
                <CardBody className="table-responsive">
                    <table className="table table-modern table-hover">
                        <thead>
                            <tr>
                                <th>Questionário</th>
                                <th>Data da Resposta</th>
                                <th>Situação</th>
                                <td aria-labelledby="Actions" />
                            </tr>
                        </thead>
                        <tbody>
                            {dataPagination(answeredSurveys, currentPage, perPage).map((item: IAnsweredSurvey) => (
                                <tr key={item.id}>
                                    <td>{item.surveyName}</td>
                                    <td>{item.answeredDate ? dayjs(item.answeredDate ).format('DD/MM/YYYY') : '-'}</td>
                                    <td>
                                        {item.status ? (
                                            <h5>
                                                <Badge color="success" className="align-items-center justify-content-center">
                                                    Ativo
                                                </Badge>
                                            </h5>
                                        ) : (
                                            <h5>
                                                <Badge color="danger" className="align-items-center justify-content-center">
                                                    Inativo
                                                </Badge>
                                            </h5>
                                        )}
                                    </td>

                                    <MoreActions
                                        id={item.id}
                                        showEdit={false}
                                        showDelete={false}
                                        customActions={[
                                            {
                                                label: 'Visualizar',
                                                icon: 'RemoveRedEye',
                                                onClickAction: () => handleAnsweredSurveyClick(item),
                                            }
                                        ]}
                                    />
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </CardBody>
                <PaginationButtons data={answeredSurveys} label="items" setCurrentPage={setCurrentPage} currentPage={currentPage} perPage={perPage} setPerPage={setPerPage} />
            </Card>
        </>
    );
};